import { useRoutes } from 'react-router-dom';

// project import
import LoginRoutes from './LoginRoutes';
import ModuleRoutes from './ModuleRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([LoginRoutes, ModuleRoutes]);
}
